import React from 'react';

import { shallowEqual, useSelector } from 'react-redux';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';
import { Divider1 } from 'styles/common';

import theme from 'constants/theme';

import { Typography14 } from 'uiToolkit/Typography';

import useLevelUpSidePanelContext from '../../context';
import CommentsList from './CommentsList';

const CommentSection = ({ comments, setComments }) => {
  const loggedInEmployeeId = useSelector(selectLoggedInEmployeeId, shallowEqual);

  const {
    state: { levelUpCompetencyDetails },
    forceReloadComments,
  } = useLevelUpSidePanelContext();

  return (
    <>
      <Divider1 topGutter={2} bottomGutter={2} />

      <Typography14 weight={600} color={theme.palette.text.blackv1} bottomGutter={2}>
        Comments
      </Typography14>
      <CommentsList
        comments={comments}
        setComments={setComments}
        employeeId={loggedInEmployeeId}
        levelUpCompetencyId={levelUpCompetencyDetails.levelUpCompetencyId}
        competencyId={levelUpCompetencyDetails.competencyId}
        levelUpId={levelUpCompetencyDetails.levelUpId}
        subCompetencyId={levelUpCompetencyDetails.subCompetencyId}
        forceReloadComments={forceReloadComments}
      />
    </>
  );
};

export default CommentSection;
